{
  "reports.title": "Reports",
  "reports.description": "Analyse ticket volume and team workload by time, project, category, channel and team.",
  "reports.tab.volume": "Volume & distribution",
  "reports.tab.workload": "Agent & team workload",
  "reports.refresh": "Refresh",
  "reports.freshness": "Updated {time}",
  "reports.scope.all": "Scope: all tickets",
  "reports.scope.mine": "Scope: tickets visible to me",
  "reports.scope.description": "Reports use the same visibility rules as ticket lists; only accounts granted global visibility see every ticket.",
  "reports.filter.range": "Date range",
  "reports.filter.range.last7": "Last 7 days",
  "reports.filter.range.last30": "Last 30 days",
  "reports.filter.range.quarter": "This quarter",
  "reports.filter.range.custom": "Custom",
  "reports.filter.range.apply": "Apply",
  "reports.filter.range.tooLong": "The range cannot exceed {days} days",
  "reports.filter.range.invalid": "Pick both a start and an end date",
  "reports.filter.granularity": "Granularity",
  "reports.filter.granularity.day": "Daily",
  "reports.filter.granularity.week": "Weekly",
  "reports.filter.granularity.month": "Monthly",
  "reports.filter.granularity.raised": "Long range — rolled up {granularity}",
  "reports.filter.project": "Project",
  "reports.filter.category": "Category",
  "reports.filter.team": "Team",
  "reports.filter.channel": "Channel",
  "reports.filter.priority": "Priority",
  "reports.filter.all": "All",
  "reports.filter.selected": "{count} selected",
  "reports.filter.compare": "Compare with previous period",
  "reports.filter.reset": "Reset filters",
  "reports.metric.created": "Created",
  "reports.metric.resolved": "Resolved",
  "reports.metric.reopened": "Reopened",
  "reports.metric.reopenRate": "Reopen rate",
  "reports.metric.netBacklogDelta": "Net backlog change",
  "reports.metric.openBacklog": "Open backlog",
  "reports.metric.unassigned": "Unclaimed",
  "reports.metric.unrouted": "Unrouted",
  "reports.metric.awaitingFirstResponse": "Unanswered",
  "reports.metric.badge.current": "Current",
  "reports.metric.badge.range": "Selected range",
  "reports.metric.comparedWithPrevious": "vs. previous period",
  "reports.metric.noComparison": "No comparable data",
  "reports.metric.resolvedHint": "Counted per resolve action: a ticket resolved, reopened and resolved again counts twice.",
  "reports.volume.title": "Ticket volume trend",
  "reports.volume.created": "Created",
  "reports.volume.resolved": "Resolved",
  "reports.volume.netBacklog": "Net backlog",
  "reports.volume.previous": "Previous period",
  "reports.volume.empty": "No ticket data in the selected range",
  "reports.distribution.title": "Distribution",
  "reports.distribution.dimension.project": "By project",
  "reports.distribution.dimension.category": "By category",
  "reports.distribution.dimension.channel": "By channel",
  "reports.distribution.dimension.priority": "By priority",
  "reports.distribution.other": "Other",
  "reports.distribution.empty": "Nothing to break down in the selected range",
  "reports.table.dimension": "Dimension",
  "reports.table.created": "Created",
  "reports.table.resolved": "Resolved",
  "reports.table.reopened": "Reopened",
  "reports.table.openBacklog": "Open now",
  "reports.table.resolutionP50": "Resolution P50",
  "reports.table.share": "Share",
  "reports.workload.noticeTitle": "How these numbers are counted",
  "reports.workload.notice": "Taken, resolved and replies are attributed to whoever performed the action; open workload and unclaimed counts follow the current owner. Reassigning a ticket moves the stock figures with it.",
  "reports.workload.scopeNotice": "Without global visibility this table only covers members of your own teams.",
  "reports.workload.teams": "Teams",
  "reports.workload.agents": "Agents",
  "reports.workload.load": "Current load",
  "reports.workload.loadDescription": "Open tickets currently assigned to each agent, for balancing reference.",
  "reports.workload.average": "Average {value}",
  "reports.workload.column.team": "Team",
  "reports.workload.column.agent": "Agent",
  "reports.workload.column.taken": "Taken",
  "reports.workload.column.resolved": "Resolved",
  "reports.workload.column.replies": "Replies",
  "reports.workload.column.activeAssigned": "Open now",
  "reports.workload.column.unassigned": "Unclaimed",
  "reports.workload.column.resolutionP50": "Resolution P50",
  "reports.workload.empty": "No workload data in the selected range",
  "reports.duration.minutes": "{count} min",
  "reports.duration.hours": "{count} hr",
  "reports.duration.days": "{count} d",
  "reports.duration.none": "—",
  "reports.drillDown": "Open in ticket list",
  "reports.tab.insight": "Issue insight",
  "reports.insight.description": "What users are running into and what is getting worse — input for product iteration, not team appraisal.",
  "reports.insight.restricted.title": "Global visibility required",
  "reports.insight.restricted.description": "Issue insight is only available to accounts with global ticket visibility. A ranking computed from one person's visible tickets is a partial view that reads like the whole product, and sends resources to the wrong place.",
  "reports.insight.dimension.category": "By category",
  "reports.insight.dimension.tag": "By tag",
  "reports.insight.ranking.title": "Issue ranking",
  "reports.insight.ranking.description": "Sorted by affected users. One large customer filing 40 tickets and 40 users filing one each mean very different things.",
  "reports.insight.column.issue": "Issue",
  "reports.insight.column.affectedUsers": "Affected users",
  "reports.insight.column.anonymousTickets": "Anonymous",
  "reports.insight.column.tickets": "Tickets",
  "reports.insight.column.growth": "Change",
  "reports.insight.column.reopenRate": "Reopen rate",
  "reports.insight.column.resolutionP50": "Resolution P50",
  "reports.insight.column.duplicates": "Duplicates",
  "reports.insight.uncategorized": "Uncategorized",
  "reports.insight.uncategorizedHint": "When auto-classification breaks, a spike in this bucket is the signal you most need to see, so it is always listed separately.",
  "reports.insight.affectedUsersHint": "Counts customers with a business identity only. Anonymous submissions create a fresh customer record each time and would inflate this systematically, so they are a separate column — the two numbers must not be added.",
  "reports.insight.new": "New",
  "reports.insight.newHint": "Absent in the previous period. Defects introduced by a new release usually look like this.",
  "reports.insight.surging.title": "Getting worse",
  "reports.insight.surging.description": "Issues past both the growth multiple and the absolute increase threshold.",
  "reports.insight.surging.empty": "Nothing is clearly worsening in this range",
  "reports.insight.emerging.title": "New this period",
  "reports.insight.emerging.description": "Issues that were absent last period and appeared in this one.",
  "reports.insight.emerging.empty": "No new issues appeared in this range",
  "reports.insight.stubborn.title": "Stubborn issues",
  "reports.insight.stubborn.description": "High reopen rate and long resolution time — fixed again and again, worth addressing at the root.",
  "reports.insight.location.title": "Where issues land",
  "reports.insight.location.pending": "Breaking issues down by app version or originating page requires agreeing on the extended-info key names with the upstream systems and adding a generated-column index for them (see design doc §6.6). Until that is done this shows nothing rather than an empty chart.",
  "reports.insight.duplicatesPending": "Pending",
  "reports.insight.duplicatesHint": "Duplicate marking is not implemented yet, so this shows “Pending” instead of 0 — a 0 would read as “no duplicates”.",
  "reports.insight.empty": "No issue data in the selected range",
  "reports.insight.untagged": "Untagged",
  "reports.insight.untaggedHint": "Tickets with no tag at all. The larger this bucket, the less the tag ranking above represents the whole picture.",
  "reports.truncated": "Too much data to compute median resolution time this time — those cells show “—”. Narrow the range or add filters."
}
